import { SampleTable } from "@/shared/components/ui";
import { useFetchAgendamientos } from "@/shared/actions/erp";
import { useCheckPermissions } from "@/shared/hooks";
import { Button, Grid } from "@mui/material";
import { OpenInNew } from "@mui/icons-material";
import { useState } from "react";
import {  Agendamiento } from "@/shared/interfaces";
import { PermissionsEnum } from "@/auth/interfaces";
import { useColumnsAgendamientos } from "@/erp/operaciones/agendamiento/shared/hooks";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";

type InfoAgendamientoProps = {
  codigo: string
}
export default function InfoAgendamiento({ 
  codigo 
}: InfoAgendamientoProps) {
  useCheckPermissions(PermissionsEnum.api_view_agendamiento);

  const { agendamientoColumnaVentas } =
  useColumnsAgendamientos();

  const [open, setOpen] = useState(false);
  const [enabled, setEnabled] = useState(false);

  const { isLoading, data: agendamientoResp,
  } = useFetchAgendamientos({
    enabled: enabled,
    params: {
      page: 1,
      page_size: 1,
      codigo
    }
  });

  return (
    <>
      <Button
        color="primary"
        startIcon={<OpenInNew />}
        onClick={() => {
          setOpen(true)
          setEnabled(true)
        }}
      >
        VER
      </Button>

      {
        open && (
          <ScrollableDialogProps
            onCloseIcon={() => setOpen(false)}
            open={open}
            title="Agendamiento"
            minWidth="75%"
            contentNode={
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <SampleTable<Agendamiento>
                    isLoading={isLoading}
                    data={agendamientoResp?.data.data || []}
                    columns={agendamientoColumnaVentas}
                    enablePagination
                  />
                </Grid>
              </Grid>
            }
          />
        )
      }
    </>
  );



}